import { Toaster as Sonner, type ToasterProps } from "sonner"
import { CircleAlertIcon, CircleCheckIcon, InfoIcon, TriangleAlertIcon, Loader2Icon } from "lucide-react"

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      closeButton
      className="toaster group"
      icons={{
        success: (
          <CircleCheckIcon className="size-4" />
        ),
        info: (
          <InfoIcon className="size-4" />
        ),
        warning: (
          <TriangleAlertIcon className="size-4" />
        ),
        error: (
          <CircleAlertIcon className="size-4" />
        ),
        loading: (
          <Loader2Icon className="size-4 animate-spin" />
        ),
      }}
      style={
        {
          "--normal-bg": "#ffffff",
          "--normal-text": "#1c1917",
          "--normal-border": "#e7e5e4",
          "--border-radius": "0.375rem",
        } as React.CSSProperties
      }
      toastOptions={{
        classNames: {
          toast: "cn-toast !relative !grid !grid-cols-[auto_minmax(0,1fr)] !items-start !gap-x-2.5 !gap-y-3 !overflow-hidden !border !border-stone-400 !bg-white !pl-5 !pr-10 !text-stone-950 !shadow-[0_18px_60px_rgba(28,25,23,0.35)]",
          error: "before:absolute before:inset-y-0 before:left-0 before:w-1 before:bg-red-700 before:content-['']",
          icon: "!col-start-1 !row-start-1 !mt-0.5",
          content: "!col-start-2 !min-w-0",
          title: "!text-stone-950",
          description: "!text-stone-700",
          actionButton: "!col-start-2 !row-start-2 !ml-0 !w-fit !justify-self-start !border !border-stone-400 !bg-stone-100 !text-stone-900 hover:!bg-stone-200",
          cancelButton: "!col-start-2 !row-start-2 !ml-0 !w-fit !justify-self-start !bg-stone-100 !text-stone-800 hover:!bg-stone-200",
          closeButton: "!absolute !left-auto !right-1 !top-[18px] !translate-x-0 !translate-y-0 !border-stone-400 !bg-white !text-stone-950 hover:!bg-stone-100 after:absolute after:-inset-3 after:content-['']",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
